import { render, staticRenderFns } from "./Pricing.vue?vue&type=template&id=955cef1e&scoped=true&"
import script from "./Pricing.vue?vue&type=script&setup=true&lang=js&"
export * from "./Pricing.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Pricing.vue?vue&type=style&index=0&id=955cef1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955cef1e",
  null
  
)

export default component.exports